// UpcomingClassesPage.jsx

import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AuthContext } from '../../../context/AuthContext';
import { Skeleton, Avatar, Box, Typography, Container, Grid, Paper } from '@mui/material';

import GetClasses from '../../../actions/course/GetClasses';
import SetPage from '../../../data/SetPage';
import GetTiming from '../../../data/GetTiming';
import ClassItem from './ClassItem'; // The newly refactored component
import noclassicon from '../../../assets/images/no-courses.svg';

const UpcomingClassesPage = ({ account }) => {
    const { user } = useContext(AuthContext);
    const { course_url, batch_id } = useParams();

    const [classes, setClasses] = useState(null);
    const [loading, setLoading] = useState(true);
    const timeOfDay = GetTiming(); // 'morning', 'afternoon', 'evening'

    useEffect(() => {
        SetPage("My Classes");
        const fetchClasses = async () => {
            const res = await GetClasses({
                payload: { user: user.SessionId, status: "incomplete", course_url, batch_id }
            });
            if (res&&res.status === "success") {
                setClasses(res.data);
            }
            setLoading(false);
        };
        fetchClasses();
    }, [user.SessionId, course_url, batch_id]);

    const renderSkeletons = () => (
        Array.from(new Array(6)).map((_, index) => (
            <Grid item xs={12} md={6} key={index}>
                <Skeleton variant="rectangular" height={235} sx={{ borderRadius: 4 }} />
            </Grid>
        ))
    );

    // Dynamic background gradient for the header
 

    return (
<>
        {account && !loading && (
              <div className={"classes-cover container d-flex align-items-center rounded "+timeOfDay}>



<div className="d-flex align-items-center text-light">

<Avatar sx={{height:60,width:60}} src={account.profile_pic}/>

<div className="ms-2">

<h3 className="mb-1 pb-0 sm-16">Good {timeOfDay} {account.first_name} !</h3>

<h6>You have {classes?classes.length:0} upcoming {classes&&classes.length>1?"Classes":"Class"}</h6>

</div>

</div>

</div>


            )}
        <Container maxWidth="lg" sx={{ py: 3 }}>
          

            <Grid container spacing={3}>
                {loading ? (
                    renderSkeletons()
                ) : classes && classes.length > 0 ? (
                    classes.map((item) => (
                        <Grid item xs={12} md={6} key={item.id}>
                            <ClassItem item={item} />
                        </Grid>
                    ))
                ) : (
                    <Grid item xs={12}>
                        <Paper sx={{ textAlign: 'center', p: 5, borderRadius: 4 }}>
                            <img src={noclassicon} alt="No classes" style={{ width: '40%', maxWidth: '200px', marginBottom: '1.5rem' }} />
                            <Typography variant="h5" gutterBottom>No Upcoming Classes</Typography>
                            <Typography color="text.secondary">
                                There are no classes scheduled for this course right now.
                            </Typography>
                        </Paper>
                    </Grid>
                )}
            </Grid>
        </Container>
        </>
    );
};

export default UpcomingClassesPage;